export interface SseFrame {
  event: string;
  data: string;
}

export class SseParser {
  private buffer = '';

  push(chunk: string): SseFrame[] {
    // Normalised on the whole buffer: a chunk may end between the \r and the \n of one line break.
    this.buffer = (this.buffer + chunk).replace(/\r\n/g, '\n');
    const blocks = this.buffer.split('\n\n');
    this.buffer = blocks.pop() ?? '';
    return blocks.map(parseBlock).filter((frame): frame is SseFrame => frame !== null);
  }
}

// A block with no data line (blank, or only ": ping" heartbeat comments) carries no event.
function parseBlock(block: string): SseFrame | null {
  let event = 'message';
  const data: string[] = [];
  for (const line of block.split('\n')) {
    if (line.startsWith('event:')) event = line.slice(6).trim();
    else if (line.startsWith('data:')) data.push(line.slice(5).replace(/^ /, ''));
  }
  return data.length > 0 ? { event, data: data.join('\n') } : null;
}

export async function* readSseFrames(
  body: ReadableStream<Uint8Array>
): AsyncGenerator<SseFrame> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  const parser = new SseParser();
  try {
    for (;;) {
      const { value, done } = await reader.read();
      if (done) return;
      yield* parser.push(decoder.decode(value, { stream: true }));
    }
  } finally {
    reader.releaseLock();
  }
}
